import React from 'react'
import { Button } from "../../Buttons/Button";
import Image from 'react-bootstrap/Image';
import PropTypes from 'prop-types';
import { isSafeUrl, isSafeImageSrc } from "../../../utils";

const DesktopView = ({href_1, href_2, showBtn_2, button_text_2, onClick_2, onClick_1, button_text_1, image, title, titleColor, children}) => {
  return (
    <div className="col-md-12 action-card-body">
            <div
              data-testid="link-card"
              className="d-flex align-items-center"
            >
              <div className="d-flex justify-content-end align-items-center">
                {isSafeImageSrc(image) && <Image src={image} className="nhs-card-image" roundedCircle />}
              </div>
              <div className="link-title">
                <h2 className="mb-2">
                  <strong className={titleColor}>{title}</strong>
                </h2>
                <div className="text-muted">{children}</div>
    
                {showBtn_2 && (
                  <span className="nhs-card-account-info">
                    Already have an account with{" "}
                    Patients Know Best?
                  </span>
                )}
    
                <div className="activate-btn-container mt-4 ageo-semibold">
                  <Button
                    className={`btn btn-green fs-16`}
                    style={{ minWidth: "160px" }}
                    label={button_text_1}
                    onClick={onClick_1 || null}
                    href={isSafeUrl(href_1) ? href_1 : undefined}
                  />
                  {showBtn_2 && (
                    <Button
                      className={`btn btn-white fs-16`}
                      style={{ minWidth: "160px" }}
                      label={button_text_2}
                      href={isSafeUrl(href_2) ? href_2 : undefined}
                      onClick={onClick_2 || null}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
  )
}

DesktopView.propTypes = {
    href_1: PropTypes.string,
    href_2: PropTypes.string,
    showBtn_2: PropTypes.bool,
    button_text_1: PropTypes.string.isRequired,
    button_text_2: PropTypes.string,
    onClick_1: PropTypes.func,
    onClick_2: PropTypes.func,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleColor: PropTypes.string,
    children: PropTypes.node
};
export default DesktopView